import type { AxiosRequestConfig, CreateAxiosDefaults } from 'axios';

import { environment } from 'src/common/environment';

export const apiDefaultSettings: CreateAxiosDefaults = {
  baseURL: environment.apiUrl,
  headers: {
    'cache-control': 'no-cache',
    Accept: 'application/json',
  },
  responseType: 'json',
};

export const apiBlobSettings: AxiosRequestConfig = {
  baseURL: environment.apiUrl,
  headers: {
    'cache-control': 'no-cache',
  },
  responseType: 'blob',
};
